import { IPersonEducator } from './iperson-educator';

export interface IPersonEducatorState {
  personEducator: IPersonEducator;
  personEducators: IPersonEducator[];
  error?: any;
  idPerson: number;
}
